<template lang="pug">
#modal-diagnostico-socioambiental
    el-dialog(
        title='Diagnóstico Socioambiental',
        width='800px',
        center=false,
        :visible.sync='mostrar',
        :before-close='fechar'
    )
        p.mb-1
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
            |
            | {{ pessoa.nomeRazaoSocial }}

        p.mb-1
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
            |
            | {{ numeralStringFormatTocpfCnpj(pessoa.cpfCnpj) }}

        p.mb-1(v-if='pessoa.email !== "-"')
            b Email:
            |
            | {{ pessoa.email }}

        DiagnosticoSocioambiental.mb-3(
            :dadosConsulta='pessoa.diagnostico',
            :cpfCnpj='pessoa.cpfCnpj'
        )

        footer(slot='footer')
            el-button(size='mini', @click='fechar') Voltar
</template>

<script>
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import formatters from '@/utils/formatters';

export default {
    name: 'ModalResultadoDiagnosticoPessoaOperacao',

    components: {
        DiagnosticoSocioambiental
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        pessoa: {
            type: Object,
            required: true
        },

        confirmar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            loadingPDF: false
        };
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatTocpfCnpj(cpfCnpj);
        }
    }
};
</script>

<style lang="scss" scoped></style>
